<template>
  <div class="store-order-detail">
    <div class="detail-header">
      <el-button type="primary" size="small" circle @click="goBack">
        <i class="el-icon-back" />
      </el-button>
      <h2>门店订单详情</h2>
    </div>

    <!-- 付款信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>付款信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端表格 -->
        <div class="pc-table">
          <div class="payment-grid">
            <div class="payment-item">
              <span class="label">付款方式：</span>
              <span class="value">{{
                paymentTypeMap[orderDetail.paymentType]
              }}</span>
              <span v-if="orderDetail.paymentType == 5">{{
                orderDetail.combinedName
              }}</span>
            </div>
            <div class="payment-item">
              <span class="label">订单编号：</span>
              <span class="value">{{ orderDetail.orderNo || '' }}</span>
            </div>
            <div class="payment-item">
              <span class="label">实付金额：</span>
              <span class="value">{{ orderDetail.amount }}</span>
            </div>
            <div class="payment-item">
              <span class="label">应收金额：</span>
              <span class="value">{{ orderDetail.actualAmount }}</span>
            </div>
            <div class="payment-item">
              <span class="label">会员优惠：</span>
              <span class="value">{{
                orderDetail.memberDiscount || '0.00'
              }}</span>
            </div>
            <div class="payment-item">
              <span class="label">减免金额：</span>
              <span class="value">{{
                orderDetail.offlineDiscount || '0'
              }}</span>
            </div>
            <div class="payment-item">
              <span class="label">优惠券金额：</span>
              <span class="value">{{
                orderDetail.couponDeductAmount || '0.00'
              }}</span>
            </div>
            <div class="payment-item">
              <span class="label">兑换卡金额：</span>
              <span class="value">{{
                orderDetail.redeemCardAmount || '0.00'
              }}</span>
            </div>
            <div v-if="orderDetail.combinedPay == 1" class="payment-item">
              <span class="label">扫码支付：</span>
              <span class="value highlight">{{ orderDetail.scanAmount }}</span>
            </div>
            <div v-if="orderDetail.combinedPay == 1" class="payment-item">
              <span class="label">会员支付：</span>
              <span class="value highlight">{{
                orderDetail.orderBalanceDeduct
              }}</span>
            </div>
            <div v-if="orderDetail.combinedPay == 1" class="payment-item">
              <span class="label">现金支付：</span>
              <span class="value highlight">{{ orderDetail.cashAmount }}</span>
            </div>
            <div class="payment-item">
              <span class="label">实收金额：</span>
              <span class="value highlight">{{
                orderDetail.actuallyPaid
              }}</span>
            </div>
          </div>
        </div>

        <!-- 移动端卡片 -->
        <div class="mobile-card">
          <div class="card-item">
            <span class="label">付款方式</span>
            <span class="value">{{
              paymentTypeMap[orderDetail.paymentType]
            }}</span>
            <span v-if="orderDetail.paymentType == 5">{{
              orderDetail.combinedName
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单编号</span>
            <span class="value">{{ orderDetail.orderNo }}</span>
          </div>
          <div class="card-item">
            <span class="label">实付金额</span>
            <span class="value">{{ orderDetail.amount }}</span>
          </div>
          <div class="card-item">
            <span class="label">应收金额</span>
            <span class="value">{{ orderDetail.actualAmount }}</span>
          </div>
          <div class="card-item">
            <span class="label">会员优惠</span>
            <span class="value">{{
              orderDetail.memberDiscount || '0.00'
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">减免金额</span>
            <span class="value">{{ orderDetail.offlineDiscount || '0' }}</span>
          </div>
          <div class="card-item">
            <span class="label">优惠券金额</span>
            <span class="value">{{
              orderDetail.couponDeductAmount || '0.00'
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">兑换卡金额</span>
            <span class="value">{{
              orderDetail.redeemCardAmount || '0.00'
            }}</span>
          </div>
          <div v-if="orderDetail.combinedPay == 1" class="card-item">
            <span class="label">扫码支付</span>
            <span class="value highlight">{{ orderDetail.scanAmount }}</span>
          </div>
          <div v-if="orderDetail.combinedPay == 1" class="card-item">
            <span class="label">会员支付</span>
            <span class="value highlight">{{
              orderDetail.orderBalanceDeduct
            }}</span>
          </div>
          <div v-if="orderDetail.combinedPay == 1" class="card-item">
            <span class="label">现金支付</span>
            <span class="value highlight">{{ orderDetail.cashAmount }}</span>
          </div>
          <div class="card-item">
            <span class="label">实收金额</span>
            <span class="value highlight">{{ orderDetail.actuallyPaid }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品列表板块 -->
    <div class="section">
      <div class="section-header">
        <h3>商品列表</h3>
      </div>
      <div class="section-content">
        <!-- PC端商品表格 -->
        <div class="pc-product-table">
          <el-table
            :data="orderDetail.orderProducts"
            stripe
            size="small"
            class="product-table"
          >
            <el-table-column
              prop="index"
              label="序号"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              min-width="150"
              align="center"
            />
            <el-table-column
              prop="productSkuAttrValue"
              label="商品规格"
              min-width="100"
              align="center"
            />
            <el-table-column
              prop="skuUnitPoint"
              label="商品价格(元)"
              width="120"
              align="center"
            />
            <el-table-column
              prop="unit"
              label="数量"
              width="100"
              align="center"
            />
            <el-table-column
              prop="totalPrice"
              label="总价格"
              width="100"
              align="center"
            />
            <el-table-column
              prop="productSkuBarCode"
              label="条形码"
              min-width="150"
              align="center"
            />
          </el-table>
        </div>

        <!-- 移动端商品卡片 -->
        <div class="mobile-product-cards">
          <div
            v-for="(product, index) in orderDetail.orderProducts"
            :key="index"
            class="mobile-product-card"
          >
            <div class="product-header">
              <div class="product-index">序号：{{ index + 1 }}</div>
              <div class="product-barcode">
                条形码：{{ product.productSkuBarCode || '-' }}
              </div>
            </div>
            <div class="product-info">
              <div class="product-name">{{ product.productName }}</div>
              <div class="product-spec">{{ product.productSkuAttrValue }}</div>
              <div class="product-price-row">
                <div class="product-price">
                  单价：{{ product.skuUnitPoint }}元
                </div>
                <div class="product-quantity">数量：{{ product.unit }}</div>
                <div class="product-total">
                  总价：{{ product.totalPrice }}元
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api_getCashierOrderDetail } from '@/api';
import constants from '@/utils/constants';

export default {
  name: 'StoreOrderDetail',
  data() {
    return {
      paymentTypeMap: constants.paymentTypeMap,
      orderDetail: {},
      products: [
        {
          name: '瀚生 炔螨特 炔螨特7...',
          spec: '1KG',
          price: 70.0,
          quantity: 4.0,
          totalPrice: 280.0,
          barcode: 'HSJMT1000'
        }
      ]
    };
  },
  created() {
    // 获取订单ID

    const orderId = this.$route.params.id;
    console.log('orderId:', orderId);
    // 模拟获取订单详情
    this.getOrderDetail(orderId);
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    // 模拟获取订单详情
    async getOrderDetail(orderId) {
      // 实际项目中，这里应该调用API获取订单详情
      console.log('获取门店订单详情:', orderId);
      try {
        const res = await api_getCashierOrderDetail({
          id: orderId
        });
        this.orderDetail = res.data || {};
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.store-order-detail {
  padding: 20px;
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.store-order-detail h2 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.store-order-detail h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

/* PC端表格样式 */
.pc-table {
  display: block;
}

.payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.payment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.payment-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.payment-item .value {
  font-size: 14px;
  color: #333;
}

.payment-item .value.highlight {
  color: #f56c6c;
  font-weight: bold;
}

/* 商品列表样式 */
.pc-product-table {
  margin-top: 15px;
}

.product-table {
  width: 100%;
  font-size: 14px;
}

/* 移动端卡片样式 */
.mobile-card {
  display: none;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.card-item:last-child {
  border-bottom: none;
}

.card-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.card-item .value {
  font-size: 14px;
  color: #333;
  text-align: right;
  flex: 1;
  margin-left: 15px;
}

.card-item .value.highlight {
  color: #f56c6c;
  font-weight: bold;
}

/* 移动端商品卡片 */
.mobile-product-cards {
  display: none;
  gap: 15px;
  margin-top: 15px;
}

.mobile-product-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.product-index {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.product-barcode {
  font-size: 12px;
  color: #666;
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}

.product-spec {
  font-size: 12px;
  color: #666;
}

.product-price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  font-size: 14px;
  font-weight: bold;
}

.product-price {
  color: #5470c6;
}

.product-quantity {
  color: #333;
}

.product-total {
  color: #f56c6c;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .store-order-detail {
    padding: 15px;
  }

  .store-order-detail h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .store-order-detail h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .section {
    padding: 15px;
    margin-bottom: 15px;
  }

  /* 隐藏PC端表格，显示移动端卡片 */
  .pc-table,
  .pc-product-table {
    display: none;
  }

  .mobile-card,
  .mobile-product-cards {
    display: block;
  }

  .payment-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .payment-item {
    padding: 8px 12px;
  }

  .payment-item .label,
  .payment-item .value {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .store-order-detail {
    padding: 10px;
  }

  .section {
    padding: 12px;
  }

  .card-item {
    padding: 10px 12px;
  }

  .card-item .label,
  .card-item .value {
    font-size: 13px;
  }

  .mobile-product-card {
    padding: 10px;
  }

  .product-name {
    font-size: 13px;
  }

  .product-spec,
  .product-barcode {
    font-size: 11px;
  }

  .product-price-row {
    font-size: 13px;
  }
}
</style>
